import { render } from "./informationMarker.vue?vue&type=template&id=c9362ed2"
import script from "./informationMarker.vue?vue&type=script&lang=js"
export * from "./informationMarker.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__